import { PERMISSIONS } from '@/lib/auth';

export const ROUTES_PERMISSIONS = {
  ['/app/av/sources/production_centers']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_PRODUCTION_CENTER,
  ['/app/av/sources/parent_broadcasters']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_CHANNEL,
  ['/app/av/sources/broadcasters']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_CHANNEL,
  ['/app/av/management/schedules']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_CHANNEL_RECORDING_SCHEDULE,
  ['/app/av/management/recordings']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_CHANNEL_RECORDING,
  ['/app/av/management/programs']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_PROGRAM,
  ['/app/av/enrichments/featured_people']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_PERSON,
  ['/app/av/enrichments/logos']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_LOGO,
  ['/app/av/enrichments/audiences']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_AUDIENCE_DATA,
  ['/app/av/enrichments/economic_value']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_ECONOMIC_VALUE_DATA,
  ['/app/av/enrichments/cnmc_reports']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_CNMC_REPORT,
  ['/app/review/broadcast_schedule']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_PROGRAM_BROADCAST,
  ['/app/review/segments']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_SEGMENT,
  ['/app/review/clips']: PERMISSIONS?.MEDIA_MANAGER?.VIEW_CLIP,
};
